module.exports = __webpack_public_path__ + "assets/cqianzhang.605e4c7c5cd3e605d02dcc15c9f842b5.png";